<template>
<div class="privacy page">

    <topheader back="/">
        <template v-slot:info>
            <span>{{$t('caption.csae')}}</span>
        </template>
    </topheader>

    <div class="work">
        <div class="privacyText" v-if="locale == 'en'">
            <h1>Child Protection and Safety Standards for Snippity</h1>
            <p>At Snippity, the safety of children from sexual violence and exploitation is of utmost importance. We comply with stringent standards set by various organizations and legal frameworks dedicated to child protection.</p>
            
            <p>Snippity is devoted to safeguarding the emotional and physical health of children. This document outlines our stringent standards for preventing child sexual abuse and exploitation in line with the Children's Online Privacy Protection Act (COPPA).</p>
            
            <h2>1. Data Collection and Privacy Policy</h2>
            <p>We have an extensive privacy policy that explains how we collect, store, and utilize users' personal data.</p>
            
            <h2>2. Monitoring and Reporting</h2>
            <p>Our application includes a monitoring system and moderators to detect instances of child sexual abuse or exploitation. Users are encouraged to report any inappropriate content or behavior.</p>
            
            <h2>3. Content Moderation</h2>
            <p>We employ proactive content moderation measures to shield users from sexual content or communications that may exploit children.</p>
            
            <h2>4. Regular Security Audits</h2>
            <p>We perform regular assessments of the app’s security features to ensure compliance with COPPA standards.</p>
            
            <h2>5. Staff Training</h2>
            <p>Our employees involved in the Snippity app receive training regarding child protection policies and legal obligations mandated by COPPA.</p>
            
            <h2>6. Cooperation with Law Enforcement</h2>
            <p>We maintain open communications with law enforcement agencies to ensure prompt responses to incidents of abuse and to aid in investigations when necessary.</p>
            
            <h2>Contact Us</h2>
            
            <p>If you have any questions, please reach out via email: <a href="mailto:support@snippity.app">support@snippity.app</a></p>
            
            <h2>Conclusion</h2>
            <p>The Snippity app acknowledges the critical necessity of protecting children from online sexual abuse and exploitation. By conforming to these standards in line with COPPA, we aim to foster a safe and enjoyable environment for children and their families.</p>
        </div>
        <div class="privacyText" v-if="locale == 'ru'">
            <h1>Стандарты защиты и безопасности детей для Snippity</h1>
            <p>В Snippity безопасность детей от сексуального насилия и эксплуатации имеет первостепенное значение. Мы соблюдаем строгие стандарты, установленные различными организациями и правовыми нормами, посвященными защите детей.</p>

            <p>Snippity стремится защищать эмоциональное и физическое здоровье детей. В этом документе изложены наши строгие стандарты по предотвращению сексуального насилия и эксплуатации детей в соответствии с Законом о защите конфиденциальности детей в Интернете (COPPA).</p>
            <h2>1. Политика сбора данных и конфиденциальности</h2>
            <p>У нас есть обширная политика конфиденциальности, которая объясняет, как мы собираем, храним и используем персональные данные пользователей.</p>

            <h2>2. Мониторинг и отчетность</h2>
            <p>Наше приложение включает в себя систему мониторинга и модераторов для обнаружения случаев сексуального насилия над детьми или эксплуатации. Пользователям рекомендуется сообщать о любом ненадлежащем контенте или поведении.</p>

            <h2>3. Модерация контента</h2>
            <p>Мы применяем меры проактивной модерации контента, чтобы оградить пользователей от сексуального контента или сообщений, которые могут эксплуатировать детей.</p>
            
            <h2>4. Регулярные проверки безопасности</h2>
            <p>Мы проводим регулярные оценки функций безопасности приложения, чтобы гарантировать соответствие стандартам COPPA.</p>

            <h2>5. Обучение персонала</h2>
            <p>Наши сотрудники, участвующие в приложении Snippity, проходят обучение по политике защиты детей и юридическим обязательствам, предписанным COPPA.</p>

            <h2>6. Сотрудничество с правоохранительными органами</h2>
            <p>Мы поддерживаем открытую связь с правоохранительными органами, чтобы обеспечить оперативное реагирование на случаи жестокого обращения и помощь в расследованиях при необходимости.</p>
            
            <h2>Свяжитесь с нами</h2>

            <p>Если у вас есть вопросы, свяжитесь с нами по электронной почте: <a href="mailto:support@snippity.app">support@snippity.app</a></p>

            <h2>Заключение</h2>

            <p>Приложение Snippity признает критическую необходимость защиты детей от сексуального насилия и эксплуатации в Интернете. Соответствуя этим стандартам в соответствии с COPPA, мы стремимся создать безопасную и приятную среду для детей и их семей.</p>
        </div>
       
    </div>
</div>
</template>

<style lang="sass" scoped>
.work 
	padding-left: 3 * $r !important
	padding-right: 2 * $r !important
	
	.privacyText 
		max-width: 740px
		padding-bottom : 8 * $r
		p 
			margin-top : $r
</style>

<script>
import { mapState } from 'vuex';

export default {
    name: 'privacy',
    components: {},

    computed: mapState({
        auth : state => state.auth,
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        }
    }),

    data : function(){

        return {
            loading : false,
            locales : {en : true, ru : true}
        }

    },

    methods: {

    }
}
</script>
